export const numberRegex = /[0-9]/g;

export const specialCharacterRegex = /[\W]/g;

export const upperCaseRegex = /[A-Z]/g;
